import { render, staticRenderFns } from "./WowzaServerForm.vue?vue&type=template&id=42790212&scoped=true&"
import script from "./WowzaServerForm.vue?vue&type=script&lang=js&"
export * from "./WowzaServerForm.vue?vue&type=script&lang=js&"
import style0 from "./WowzaServerForm.vue?vue&type=style&index=0&id=42790212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42790212",
  null
  
)

export default component.exports